<script lang="ts" setup>
  import InputWrapper from '../InputWrapper/InputWrapper.vue';
  import { useAttrs } from 'vue';
  import type { TextInputProps } from '../TextInput';

  export type TextAreaResize = 'none' | 'both' | 'horizontal' | 'vertical';
  export type TextAreaProps = TextInputProps & {
    modelValue?: string;
    cols?: number;
    rows?: number;
    wrap?: 'soft ' | 'hard';
    maxLength?: number;
    resize?: TextAreaResize;
    minHeight?: string;
  };

  withDefaults(defineProps<TextAreaProps>(), {
    optionalLabel: false,
    disabled: false,
    type: 'text',
    placeholder: '',
    meta: undefined,
    resize: 'vertical',
    rows: 4,
    minHeight: undefined,
  });

  const emit = defineEmits<{
    'update:modelValue': [value: string];
    blur: [value: string];
  }>();

  defineOptions({
    inheritAttrs: false,
  });
  const attrs = useAttrs();
</script>

<template>
  <InputWrapper
    :id="id"
    :class="attrs.class"
    :width="width"
    :error="error"
    :label="label"
    :loading="loading"
    :meta="meta"
    :optional-label="optionalLabel"
  >
    <template #inputLabel> <slot name="inputLabel"></slot> </template>
    <template #inputError> <slot name="inputError"></slot> </template>
    <template #iconRight> <slot name="iconRight"></slot> </template>
    <template #default="slotProps">
      <textarea
        :id="id"
        :aria-required="!optionalLabel"
        :class="slotProps.slotClass"
        :data-test-id="testId"
        :disabled="disabled || loading"
        :name="name"
        :placeholder="placeholder"
        :style="{
          resize: resize,
          minHeight: minHeight,
          height: minHeight ? 'auto' : undefined,
        }"
        :value="modelValue"
        :rows="rows"
        :cols="cols"
        :wrap="wrap"
        :maxlength="maxLength"
        @blur="emit('blur', ($event.target as HTMLTextAreaElement).value)"
        @input="
          emit('update:modelValue', ($event.target as HTMLInputElement).value)
        "
      ></textarea>
    </template>
  </InputWrapper>
</template>
